(() => {
  if (window.wpUpsellControlsLoaded) return;
  window.wpUpsellControlsLoaded = true;
  const style = document.createElement('style');
  style.textContent = '.wp-kit-choices{display:grid;gap:10px;margin:8px 0 16px}.wp-kit-choice{display:grid;gap:4px;font-size:14px;color:#4A4032}.wp-kit-choice select{width:100%;min-width:0;max-width:100%;padding:9px 7px;border:1px solid #34573c66;border-radius:7px;background:#fff;color:#4A4032;font:inherit;font-size:14px}.wp-pkit__body{min-width:0}.wp-kit-choice select:focus-visible{outline:2px solid #34573C;outline-offset:2px}';
  document.head.appendChild(style);
  function updateKit(kit) {
    const choices = Array.from(kit.querySelectorAll('[data-wp-kit-variant]'));
    if (!choices.length) return;
    const pictures=kit.querySelectorAll('.wp-pkit__piece img,.wp-kit__piece img');
    choices.forEach((select,i)=>{const url=select.selectedOptions[0]?.dataset.image;if(url && pictures[i])pictures[i].src=url;});
    const sum = choices.reduce((n,s) => n + Number(s.selectedOptions[0]?.dataset.price || 0),0);
    const discounted = choices.reduce((n,s) => {const p=Number(s.selectedOptions[0]?.dataset.price || 0);return n+p-Math.round(p*0.2);},0);
    const fmt = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:kit.dataset.currency || 'EUR'});
    const money = n => fmt.format(n/100);
    kit.querySelector('.wp-pkit__now,.wp-kit__now').textContent = money(discounted);
    const meta = kit.querySelector('.wp-pkit__meta,.wp-kit__meta');
    meta.textContent = money(sum)+' '+kit.dataset.separate+' · '+kit.dataset.save+' '+money(sum-discounted);
    const badge=kit.querySelector('[data-saving-label]');if(badge)badge.textContent=badge.dataset.savingLabel+' '+money(sum-discounted);
    kit.querySelector('[data-ids]').dataset.ids = choices.map(s=>s.value).join(',');
  }
  document.querySelectorAll('[data-wp-kit]').forEach(updateKit);
  document.addEventListener('change', e => {
    if (e.target.matches('[data-wp-kit-variant]')) updateKit(e.target.closest('[data-wp-kit]'));
    if (e.target.matches('.wp-upsell__choice')) { const card=e.target.closest('.wp-upsell__card,.wp-comp__card');card.querySelector('.wp-upsell__price,.wp-comp__p').textContent=e.target.selectedOptions[0].dataset.money;const img=card.querySelector('img');if(img && e.target.selectedOptions[0].dataset.image)img.src=e.target.selectedOptions[0].dataset.image; }
  });
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-wp-kit]').forEach(updateKit));
  document.addEventListener('submit', async event => {
    const form=event.target.closest('.wp-upsell__form');
    if(!form) return;
    event.preventDefault();
    const button=form.querySelector('button[type="submit"]');
    if(button.disabled) return;
    const label=button.textContent;
    button.disabled=true;button.textContent='…';
    form.querySelector('[role="alert"]')?.remove();
    try {
      let drawer=document.querySelector('cart-drawer');
      if(drawer && !drawer.renderContents) await Promise.race([customElements.whenDefined('cart-drawer'),new Promise(r=>setTimeout(r,3000))]);
      drawer=document.querySelector('cart-drawer');
      const body={items:[{id:Number(form.elements.id.value),quantity:1}]};
      if(drawer?.getSectionsToRender){body.sections=drawer.getSectionsToRender().map(s=>s.section||s.id);body.sections_url=location.pathname;}
      const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
      const data=await response.json();
      if(!response.ok || data.status) throw new Error(data.description || form.dataset.error);
      if(drawer?.renderContents && data.sections){drawer.classList.remove('is-empty');drawer.renderContents(data);}
      else location.href=(window.Shopify?.routes?.root||'/')+'cart';
    } catch(error) {
      const alert=document.createElement('p');alert.setAttribute('role','alert');alert.style.fontSize='14px';alert.textContent=error.message||form.dataset.error;form.appendChild(alert);
    } finally {button.disabled=false;button.textContent=label;}
  });
  // Listen after Dawn's variant UI updates; mirror the main product choice into the kit.
  function syncMainVariant() {
    const kit=document.querySelector('#wp-pdp-kit [data-wp-kit]');
    const form=document.querySelector('product-info form[action$="/cart/add"]');
    const id=form?.querySelector('[name="id"]')?.value;
    const select=kit?.querySelector('[data-wp-kit-variant]');
    if(select && id && Array.from(select.options).some(o=>o.value===id)){select.value=id;updateKit(kit);}
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange,syncMainVariant);
})();
